import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage, GatsbyImageProps, getImage } from 'gatsby-plugin-image'

export interface ImageProps {
  id?: string
  filename?: string
  url?: string
  alt?: string
}

const Image = (options: ImageProps) => {
  // placeholderImage: file(relativePath: { eq: "gatsby-astronaut.png" }) {
  // fluid(maxWidth: 124, maxHeight: 124, quality: 80) {
  const { id, filename, url, alt } = options
  // "gatsby-astronaut.png"

  /* Need to use layout full width because of following accessibility error:
   Bad value ___ for attribute ___ on element ___:
   Illegal character in scheme data: space is not allowed.
   An img element which has an alt attribute whose value is the empty 
   string must not have a role attribute. */
  const data = useStaticQuery(graphql`
    query {
      images: allFile {
        edges {
          node {
            id
            relativePath
            publicURL

            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
            }
          }
        }
      }
    }
  `)

  let checkType: undefined | string = undefined

  if (typeof id !== 'undefined') {
    checkType = 'id'
  } else if (typeof filename !== 'undefined') {
    checkType = 'filename'
  } else if (typeof url !== 'undefined') {
    checkType = 'url'
  } else {
    return <></>
  }

  const image = data.images.edges.find((n: any) => {
    return (
      (checkType === 'url' && n.node.publicURL === url) ||
      (checkType === 'id' && n.node.id === id) ||
      n.node.relativePath.includes(filename)
    )
  })

  if (!image || !image.node || !image.node.childImageSharp) {
    return <></>
  } else {
    const i = getImage(image.node.childImageSharp)

    if (typeof i == 'undefined') {
      return <></>
    } else {
      const props: GatsbyImageProps = {
        image: i,
        alt: '',
      }

      if (alt && alt !== '') {
        props.alt = alt
      }

      return <GatsbyImage {...props} />
    }
  }
}

export default Image
